export const USER_ERROR_TAG = '<user-error>'

export default function getUserErrorFromAPIResponse(
  message: string
): string | null {
  const match = message.match(/<user-error>(.*?)<\/user-error>/)
  return match ? match[1] : null
}
